import DeleteIcon from '@material-ui/icons/Delete';
import { FC, Fragment, memo, useEffect, useState } from "react";
import { Button, FieldProps, useDataProvider, useNotify, useRecordContext } from "react-admin";
import Clear from '../form/Clear';
import Loader from "../form/Loader";
import { FileUpload, openFile, REACT_APP_FILES_URL, removeFile } from "./fn";

interface FileFieldProps extends FieldProps {
    disabled?: boolean;
}

const FileField: FC<FileFieldProps> = memo((props: FileFieldProps) => {
    const [children, setChildren] = useState(null);
    const dataProvider = useDataProvider();
    const record = useRecordContext();
    const notify = useNotify();
    const { source, resource, disabled } = props;
    useEffect(() => {
        const removeItemFromRecord = (itemId) => {
            const id = record.id;
            const data = {};
            const previousData = record;
            if (typeof record[source] === "number" || record[source].length === 1) {
                data[source] = null;
            } else {
                data[source] = "{" + record[source].filter(v => v !== itemId) + "}";
            }
            return dataProvider.update(resource, {
                id,
                data,
                previousData
            });
        }
        const ids = typeof record[source] === "number" ? [record[source]] : record[source];
        if (ids?.length > 0) {
            dataProvider.getMany<FileUpload>("file", { ids }).then(({ data }) => {
                const children = [];
                for (const item of data) {
                    if (item) {
                        const size = (item.size > 1e+6) ? `${item.size / 1e+6} mo` : ((item.size > 1000) ? `${Math.round(item.size / 1000)} ko` : `${item.size} octet`)
                        children.push(<div key={item.id} onClick={() => openFile(item)} className={`file ${item.extension}`}>
                            <Button style={{ visibility: disabled ? "hidden" : "visible" }} onClick={(e) => { e.stopPropagation(); removeFile(dataProvider, item, notify, removeItemFromRecord) }} className="remove" size="large"><DeleteIcon color="error" /></Button>
                            <div className="infos">
                                <div>{item.name}</div>
                                <div>{size}</div>
                            </div>
                            {item.type.startsWith("image") && <img src={`${REACT_APP_FILES_URL}${item.tusId}`} width="150" height="150" alt="preview" />}
                        </div>);
                    }
                };
                setChildren(children);
            });
        } else {
            setChildren([]);
        }
    }, [record, dataProvider, disabled, notify, resource, source]);
    if (children === null) return <Loader />;
    return <Fragment>{children}<Clear /></Fragment>
});

FileField.defaultProps = {
    disabled: false
}

export default FileField;